import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "loadingLayer"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "page page-reports page-table hide-calendar"
}
const _hoisted_5 = { class: "selector" }
const _hoisted_6 = { class: "page-table-body-wrapper flex" }
const _hoisted_7 = { class: "page-table-body page-reports-body page-soil-body" }
const _hoisted_8 = { class: "page-table-body page-reports-body usage-guide-table" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "項目"),
  /*#__PURE__*/_createElementVNode("th", null, "内容"),
  /*#__PURE__*/_createElementVNode("th", null, "設定値")
], -1)
const _hoisted_10 = { rowspan: "2" }
const _hoisted_11 = { class: "rain-caution" }
const _hoisted_12 = { class: "rain-warning" }
const _hoisted_13 = { class: "rain-warning" }
const _hoisted_14 = { class: "rain-warning" }
const _hoisted_15 = { class: "rain-warning" }
const _hoisted_16 = { rowspan: "3" }
const _hoisted_17 = { class: "soil-caution" }
const _hoisted_18 = { class: "soil-warning" }
const _hoisted_19 = { class: "soil-danger" }

import { onMounted, watch, computed, ref } from 'vue'
import $ from 'jquery'
import moment from 'moment'
import { useRoute } from 'vue-router'
import { camelCase } from 'lodash'
import ControllPanel from '@/components/common/ControllPanel.vue'
import DataTable from '@/components/reports/DataSoilTable.vue'
import StationSelector from '@/components/common/StationSelector.vue'
import { useReportData } from '@/stores/reportDataStore'
import { useGlobalStore } from '@/stores/globalStore'
import { HEADER_SIZE, HEADER_MARGIN, CONTROLLER_SIZE, TABLE_MARGIN, TABLE_HEADER_SIZE } from '@/lib/constants'
import { useInitDataStore } from '@/stores/initDataStore'
import axios from 'axios'
import { GpvRepository } from '@/repositories/gpv-repository'
import { Option } from '@/components/common/UdcSelect.vue'

type Row = {
  values: (string | undefined)[]
}

type fieldType = string[]

type waterLevelType = {
  station_id: string
  water_level: number
}

type soilStationIndexPoint = {
  station_id: string
  soil_index_point: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const REPORT_TYPES = {
  RAIN_HOURY: 'rain_hourly',
  RAIN_RUISEKI: 'rain_rui',
}

const REPORT_TYPE_RESOLUTION = {
  [REPORT_TYPES.RAIN_HOURY]: 'hour',
  [REPORT_TYPES.RAIN_RUISEKI]: 'rui',
}

const DEFAULT_AREA_CODE = 'area-01'

const USAGE_GUIDE_TITLE = {
  TEN_MINUTES: '10分積算雨量',
  TOTAL_HOUR: '時間積算雨量',
  TOTAL_TWO_HOURS: '2時間積算雨量',
  TOTAL_THREE_HOURS: '3時間積算雨量',
  SOIL: '土壌雨量指数',
}

const ARERT_RAIN_LABELS = {
  CAUTION: '注意',
  WARNING: '警報',
  DANGER: '危険',
}

const ARERT_SOIL_LABELS = {
  CAUTION: '注意(60%)',
  WARNING: '警報(80%)',
  DANGER: '危険(100%)',
}

const SETTING_NUM = {
  TEN_MINUTES_CAUTION: '10mm以上',
  TEN_MINUTES_WARNING: '20mm以上',
  TOTAL_HOUR_WARNING: '80mm以上',
  TOTAL_TWO_HOURS_WARNING: '120mm以上',
  TOTAL_THREE_HOURS_WARNING: '145mm以上',
  SOIL_CAUTION: '142mm以上',
  SOIL_WARNING: '190mm以上',
  SOIL_DANGER: '238mm以上',
}

const route = useRoute()
const queryDate = route.query.date as string

const reportType = ref<string>(REPORT_TYPES.RAIN_HOURY)
const date = ref<Date>(moment(queryDate || new Date()).toDate())
const loading = ref<boolean>(true)
const repository = new GpvRepository()

// 水位
const definitionInfoWater = computed(() => {
  return initDataStore.definitionInfoWater(resolution.value)
})

const globalStore = useGlobalStore()
const initDataStore = useInitDataStore()
const reportData = useReportData()

const selectRange = computed((): Range => {
  const format = 'YYYY-MM-DD HH:mm:ss'

  return {
    startTime: moment().add(-180, 'minute').format(format),
    endTime: moment().format(format),
  } as Range
})

const headerUnits = computed(() => {
  const fields = initDataStore.initData.definitionInfo.soilwater.items[0].fieldId as fieldType

  return fields.map((key: string) => {
    const field = initDataStore.fieldListItem(camelCase(key))

    return {
      key,
      name: field.name,
    }
  })
})

const thresholds = computed(() => {
  type soilwaterThreshold = {
    fieldId: string
    name: string
    threshold: Threshold[]
  }
  type Threshold = {
    color: string
    comparison: number
    type: string
  }

  const results = [] as Threshold[]

  initDataStore.initData.definitionInfo.soilwater.threshold.forEach((e: soilwaterThreshold) => {
    e.threshold.forEach((element: Threshold) => {
      results.push(element)
    })
  })
  return results
})

const stationId = computed(() => {
  return globalStore.currentStation?.stationId
})

const currentArea = computed(() => {
  return globalStore.currentArea || initDataStore.findArea(DEFAULT_AREA_CODE)
})

const fetch = async () => {
  loading.value = true

  if (!currentArea.value) {
    return
  }
  const stations = currentArea.value.stations()
  const stationIds = stations.map(s => s.stationId)
  const type = REPORT_TYPE_RESOLUTION[reportType.value]
  const range = selectRange.value

  if (!stationId.value) {
    loading.value = false
    return
  }

  const target = headerUnits.value.map((v: Option) => v.key)

  await reportData.fetch(stationIds, type, range, target)

  getWaterLevel()
  getSoilIndexPoint()
}

const waterLevel = ref<waterLevelType[]>()

const getWaterLevel = async () => {
  type currentTargets = {
    station_id: string
    target: string[]
  }
  let targets = [] as currentTargets[]
  definitionInfoWater.value?.items.forEach(station => {
    targets.push({
      station_id: station.stationId,
      target: ['water_level'],
    })
  })
  const response = await axios.post(`/api/current`, {
    station_list: targets,
  })

  let res = [] as waterLevelType[]
  if (response.data.items) {
    type stationSoilData = {
      water_level: number
      station_id: string
      time: string
    }
    response.data.items.forEach((e: stationSoilData) => {
      res.push({
        station_id: e.station_id,
        water_level: e.water_level,
      })
    })
  }

  waterLevel.value = res
}

const soilIndexPoint = ref<soilStationIndexPoint[]>()

const getSoilIndexPoint = async () => {
  const time_res = await repository.getTime()
  const basetime = time_res.dojou.baseTime
  let res = [] as soilStationIndexPoint[]

  for (const station of currentStations.value) {
    const response = await axios.get(
      `/api/gpv/dojou_point/${station.longitude}/${station.latitude}?base_time=${basetime}`
    )
    let level = '-'
    if (response.data) level = String(response.data.slice(-1)[0].val)
    res.push({
      station_id: station.stationId,
      soil_index_point: level,
    })
  }

  soilIndexPoint.value = res
  loading.value = false
}

const currentStations = computed(() => {
  return currentArea.value ? currentArea.value.stations() : initDataStore.initData.stationList
})

// 表示するデータ
const rows = computed(() => {
  const results = [] as Row[]
  const stations = currentStations.value

  if (initDataStore.initData.definitionInfo.soilwater.items) {
    // 該当の地域をループ
    for (const station of initDataStore.initData.definitionInfo.soilwater.items) {
      const now_station = stations.filter(s => s.stationId === station.stationId)
      // 対象であれば、表示対象に追加
      if (now_station && now_station[0]) {
        const row = {
          values: [] as string[],
        } as Row
        row.values.push(now_station[0].name)
        row.values.push(currentArea.value?.name)

        // 初期値として中身を空の状態で設定
        for (let i = 0; i < 6; i++) {
          row.values.push('-')
        }

        // 雨量がある
        if (station.fieldId.includes('move_rain_min_10')) {
          // 対象のIDからレポートデータを取得
          const stationValues = reportData.data[station.stationId]
          if (stationValues) {
            // 新しいものを先頭に持ってくる
            let reverse_station_values = stationValues.sort(function (a, b) {
              return a.time > b.time ? -1 : 1
            })
            // 表示対象の時間配列があれば、表示に追加
            if (reverse_station_values.length > 0) {
              let total_rainfall = 0
              reverse_station_values.forEach((val, j) => {
                total_rainfall += val.moveRainMin10 ?? 0
                if (j === 0) {
                  // 10分前
                  row.values[2] = formatDigitNumbers(total_rainfall, 1)
                } else if (j > 0 && j <= 5) {
                  // 1時間前までの合計( 間が空いていても表示 )
                  row.values[3] = formatDigitNumbers(total_rainfall, 1)
                } else if (j > 5 && j <= 11) {
                  // 2時間前までの合計( 間が空いていても表示 )
                  row.values[4] = formatDigitNumbers(total_rainfall, 1)
                } else if (j > 11 && j <= 17) {
                  // 3時間前までの合計( 間が空いていても表示 )
                  row.values[5] = formatDigitNumbers(total_rainfall, 1)
                }
              })
            }
          }
        }

        // 土壌雨量指数
        const currentsoilIndexPoint = soilIndexPoint.value?.filter(st => st.station_id == station.stationId)
        if (currentsoilIndexPoint && currentsoilIndexPoint[0]) {
          row.values[6] = currentsoilIndexPoint[0].soil_index_point
        }

        // 水位
        if (station.fieldId.includes('water_level')) {
          const currentWaterLevel = waterLevel.value?.filter(st => st.station_id == station.stationId)
          if (currentWaterLevel && currentWaterLevel?.length > 0 && currentWaterLevel[0].water_level) {
            row.values[7] = formatDigitNumbers(currentWaterLevel[0].water_level, 2)
          }
        }
        results.push(row)
      }
    }
  }

  return results
})

const tableHeight = computed(() => {
  let height = rows.value.length * 32
  let root_height =
    ($('.root').height() as number) - HEADER_SIZE - HEADER_MARGIN - CONTROLLER_SIZE - TABLE_MARGIN - TABLE_HEADER_SIZE

  if (height > root_height) {
    height = root_height
  } else {
    height = height + (16 - 2 * rows.value.length)
  }

  return `height: ${height}px`
})

const resolution = computed(() => {
  return REPORT_TYPE_RESOLUTION[reportType.value]
})

const handleScrollBody = () => {
  const $header = $('#tableHead')
  const $tableBodyWrapper = $('.table-body-wrapper')
  const left = $tableBodyWrapper.scrollLeft()

  $header.css('left', `-${left}px`)
}

onMounted(async () => {
  const $tableBodyWrapper = $('.table-body-wrapper')

  $tableBodyWrapper.on('scroll', handleScrollBody)

  reportType.value = REPORT_TYPES.RAIN_HOURY
  date.value = moment(route.query.date as string).toDate()

  fetch()
})

watch(() => globalStore.currentArea, fetch)

/**
 * 指定桁数まで小数点桁を付与、指定した数で小数点以下を切り捨て
 * @param value number 小数点を付与したい値
 * @param numberOfDigits number 付与する小数点の桁数
 * @return string 小数点を付与した数値の文字列
 */
function formatDigitNumbers(value: number, numberOfDigits: number) {
  if (numberOfDigits <= 0) {
    return String(Math.floor(value))
  }
  let result = String(value)
  let digitSplit = result.split('.')
  if (digitSplit.length === 1) {
    // 小数点がない
    // 小数点を付与して指定桁数まで0で補う
    result = String(digitSplit[0]) + '.'
    for (let i = 0; i < numberOfDigits; i++) {
      result += '0'
    }
  } else {
    // 小数点が存在
    // 小数点の桁数をチェック
    if (digitSplit[1].length < numberOfDigits) {
      // 桁数不足
      for (let i = digitSplit[1].length; i < numberOfDigits; i++) {
        result += '0'
      }
    } else if (digitSplit[1].length > numberOfDigits) {
      // 桁数オーバー
      result = digitSplit[0] + '.' + digitSplit[1].substr(0, numberOfDigits)
    }
  }
  return result
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(ControllPanel, {
            "default-date": date.value,
            "show-resolution": false,
            "default-resolution": _unref(resolution)
          }, {
            left: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(StationSelector, {
                  "default-area": DEFAULT_AREA_CODE,
                  "station-type": _ctx.stationType,
                  "show-stations": false
                }, null, 8, ["station-type"])
              ])
            ]),
            _: 1
          }, 8, ["default-date", "default-resolution"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(DataTable, {
                rows: _unref(rows),
                thresholds: _unref(thresholds),
                style: _normalizeStyle(_unref(tableHeight))
              }, null, 8, ["rows", "thresholds", "style"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("table", null, [
                  _hoisted_9,
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_10, _toDisplayString(USAGE_GUIDE_TITLE.TEN_MINUTES), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(ARERT_RAIN_LABELS.CAUTION), 1),
                    _createElementVNode("td", null, _toDisplayString(SETTING_NUM.TEN_MINUTES_CAUTION), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_12, _toDisplayString(ARERT_RAIN_LABELS.WARNING), 1),
                    _createElementVNode("td", null, _toDisplayString(SETTING_NUM.TEN_MINUTES_WARNING), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(USAGE_GUIDE_TITLE.TOTAL_HOUR), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(ARERT_RAIN_LABELS.WARNING), 1),
                    _createElementVNode("td", null, _toDisplayString(SETTING_NUM.TOTAL_HOUR_WARNING), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(USAGE_GUIDE_TITLE.TOTAL_TWO_HOURS), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(ARERT_RAIN_LABELS.WARNING), 1),
                    _createElementVNode("td", null, _toDisplayString(SETTING_NUM.TOTAL_TWO_HOURS_WARNING), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(USAGE_GUIDE_TITLE.TOTAL_THREE_HOURS), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(ARERT_RAIN_LABELS.WARNING), 1),
                    _createElementVNode("td", null, _toDisplayString(SETTING_NUM.TOTAL_THREE_HOURS_WARNING), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_16, _toDisplayString(USAGE_GUIDE_TITLE.SOIL), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(ARERT_SOIL_LABELS.CAUTION), 1),
                    _createElementVNode("td", null, _toDisplayString(SETTING_NUM.SOIL_CAUTION), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_18, _toDisplayString(ARERT_SOIL_LABELS.WARNING), 1),
                    _createElementVNode("td", null, _toDisplayString(SETTING_NUM.SOIL_WARNING), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_19, _toDisplayString(ARERT_SOIL_LABELS.DANGER), 1),
                    _createElementVNode("td", null, _toDisplayString(SETTING_NUM.SOIL_DANGER), 1)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})